(function () {
    'use strict';

    angular
        .module('app.helpText')
        .factory('helpTextFactory', helpTextFactory);

    helpTextFactory.$inject = ['dataservice', '$q'];
    /* @ngInject */
    function helpTextFactory(dataservice, $q) {
        var service = {
            cachedData: null,
            helpTextData: getHelpTextData
        };

        return service;

        function getHelpTextData(forceReload) {
            var deferred = $q.defer();

            if (!this.cachedData || forceReload) {
                dataservice.getItems("api/HelpText/ForDisplay").then(function (response) {
                    deferred.resolve(response.data);
                });
                this.cachedData = deferred.promise;
            }
            
            return this.cachedData;
            /*
            if (cachedData && !forceReload) {
                return $q.resolve(this.cachedData);
            }
            else {
                return dataservice.getItems("api/HelpText/ForDisplay").then(function (response) {
                    cachedData = response.data;
                    console.log(cachedData);
                    return $q.resolve(cachedData);
                }, function (error) { });
            }*/
        }

    }
})();
